import React from 'react';

import formatDate from 'Shared/util/formatDate';

const LeftPart = ({ data }) => {
  const { reference, title, createdAt, dueDate, paidDate, bank, messageToBeneficiary, supplier, customer } = data;
  return (
    <div className="tab-invoice-detail__left-part">
      <div className="tab-invoice-detail__paper">
        <div className="header">
          <span className="header__title">{reference}</span>
          <span className="header__label">{title}</span>
          {dueDate && (
            <div className="header__date date--warning" data-testid="invoice-date">
              Due on {formatDate(dueDate)}
            </div>
          )}
          {paidDate && (
            <div className="header__date date--success" data-testid="paid-invoice-date">
              Paid on {formatDate(paidDate)}
            </div>
          )}
        </div>
        <div className="paper-container">
          <div className="paper-container__row">
            <div className="cell">
              <div className="paper-label">Issue date</div>
              <div className="paper-title">{formatDate(createdAt)}</div>
            </div>
            <div className="cell">
              <div className="paper-label">{dueDate ? 'Due date' : 'Paid date'}</div>
              <div className="paper-title">{dueDate ? formatDate(dueDate) : formatDate(paidDate)}</div>
            </div>
          </div>
        </div>
        {supplier && (
          <div className="paper-container">
            <div className="paper-container__row">
              <div className="cell">
                <div className="paper-label">Supplier</div>
                <div className="paper-title">{supplier.title}</div>
                <div className="paper-description">{supplier.address1}</div>
              </div>
            </div>
            <div div className="paper-container__row">
              <div className="cell">
                <div className="paper-label">Registration number</div>
                <div className="paper-title">{supplier.vatNumber}</div>
              </div>
            </div>
          </div>
        )}
        {customer && (
          <div className="paper-container">
            <div className="cell">
              <div className="paper-label">Customer</div>
              <div className="paper-title">{customer.title}</div>
              <div className="paper-description">{customer.address1}</div>
            </div>
          </div>
        )}
        {bank && (
          <div className="paper-container">
            <div className="paper-container__row">
              <div className="cell">
                <div className="paper-label">Bank</div>
                <div className="paper-title">{bank.name}</div>
                <div className="paper-description">{bank.address}</div>
              </div>
            </div>
            <div className="paper-container__row">
              <div className="cell">
                <div className="paper-label">Swift Code</div>
                <div className="paper-title">{bank.swiftCode}</div>
              </div>
            </div>
            <div className="paper-container__row">
              <div className="cell">
                <div className="label">Bank account</div>
                <div className="bank_account">{bank.accountId}</div>
              </div>
            </div>
            <div className="paper-container__row">
              <div className="cell">
                <div className="label">IBAN</div>
                <div className="bank_account">{bank.iban}</div>
              </div>
            </div>
            <div className="paper-container__row">
              <div className="cell">
                <div className="paper-label">Message to Beneficiary</div>
                <div className="bank_account">{messageToBeneficiary}</div>
              </div>
            </div>
          </div>
        )}

        <div className="paper-container">
          <div className="paper-container__row">
            <div className="cell">
              <div className="paper-label">Represented by Andrey Zarubin, who acts according to the charter</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftPart;
